import styled from "@emotion/styled";
import { Shimmer } from "react-shimmer";

export const TextShimmer = styled(Shimmer)`
  border-radius: 6px;
  margin: 2px 0;
`;

export const CircleShimmer = styled(Shimmer)`
  border-radius: 50%;
`;

export const BoxShimmer = styled(Shimmer)`
  border-radius: 6px;
`;
